/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import { compose } from 'recompose';
import { connect, useSelector } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import {
    object, bool, shape,
} from 'prop-types';
import ReactHTMLParser from 'react-html-parser';
import Data from './ViewData';
import ContactUsBannerContainer from '../ContactUsBanner/ContactUsBannerContainer';
import GraphqlSeoHeadTags from '../../GraphqlCommonComponents/GraphqlSeoHeadTags/GraphqlSeoHeadTags';
import { getFeatureFlags } from '../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import { getOperatingSystem } from '../../../../../state/ducks/App/ducks/Config/Config-Helpers';
import { getCurrentBrandId } from '../../../../pages/Account/utils/featureSelectors';
import triggerPopChatEvent from '../../../MultiBrandChatController/AigoChatWidgetWrapperV2/popOpenChat';
import { getProfileInfo } from '../../../../../state/ducks/App/ducks/Common/Common-Selectors';

const styles = (theme) => ({
    container: {
        [theme.breakpoints.down('sm')]: {
            maxWidth: theme.palette.tiers.container.maxWidth.downSmall,
            margin: '0 auto',
            padding: '0 15px',
        },
        [theme.breakpoints.down('md')]: {
            maxWidth: theme.palette.tiers.container.maxWidth.downMedium,
            margin: '0 auto',
        },
        [theme.breakpoints.up('md')]: {
            maxWidth: 980,
            margin: '0 auto',
        },
        [theme.breakpoints.up('lg')]: {
            maxWidth: 980,
            margin: '0 auto',
        },
    },
    title: {
        '& h2': {
            fontSize: 28,
            textAlign: 'center',
        },
        '& p': {
            fontSize: 15,
            margin: 'auto',
            maxWidth: '85%',
            marginBottom: 10,
            '& button': {
                cursor: 'pointer',
                padding: 0,
                fontSize: 15,
                background: theme.palette.common.white,
                borderStyle: 'none',
                textDecoration: 'underline',
            },
        },
    },
    chatLinkBtn: {
        border: 'none',
        background: 'none',
        cursor: 'pointer',
        textDecoration: 'underline',
        fontSize: '15px',
        fontFamily: theme.typography.fontFamily,
        color: theme.palette.text.primary,
    },
});

const CustomerServiceDifferentIssuePage = ({
    classes, page, brand, featureFlags,
}) => {
    const { title = '', description = '', seo = {} } = Data;
    const isChatEnabled = featureFlags['is-chat-icon-displayed'] || featureFlags['is-conv-ui-enabled'];
    const operatingSystem = getOperatingSystem().toLowerCase();
    const currentBrand = useSelector((state) => getCurrentBrandId(state));
    const customerData = useSelector((state) => state?.member);
    const profile = useSelector(getProfileInfo);
    const userData = {
        firstName: profile?.firstName || '',
        lastName: profile?.lastName || '',
        email: profile?.email || '',
    };
    return (
        <>
            <GraphqlSeoHeadTags seoData={seo} />
            <Grid container className={classes.container}>
                <Grid className={classes.title} item xs={12}>
                    <h2>{title}</h2>
                    <p>If you or your recipient are still not satisfied with the experience, you can {isChatEnabled ? (
                        <button
                            type="button"
                            className={classes.chatLinkBtn}
                            onClick={() => triggerPopChatEvent(userData, operatingSystem, currentBrand, featureFlags, customerData)}
                        ><span>chat with us.</span>
                        </button>
                    ) : 'chat with us.'}
                    </p>
                    {ReactHTMLParser(description)}
                </Grid>
            </Grid>
            <ContactUsBannerContainer page={page} brand={brand} />
        </>
    );
};

CustomerServiceDifferentIssuePage.propTypes = {
    classes: object.isRequired,
    page: object.isRequired,
    brand: object.isRequired,
    featureFlags: shape({
        'is-webchat-enabled': bool,
    }).isRequired,
};

const mapStateToProps = (state) => ({
    featureFlags: getFeatureFlags(state),
});

const enhance = compose(
    connect(mapStateToProps),
    withStyles(styles),
);

export default enhance(CustomerServiceDifferentIssuePage);
